/* HALO Dennis (Umzug Baustein 04, v017i)
   Eine rAF-Schleife fuer die ganze Seite. Jeder Abschnitt liest seine
   eigene Position und schreibt Styles direkt, keine Bibliothek.
   Mechaniken nach SELENE (Strecke, Filmrolle) und VALMORA (Laufband,
   Tuch), uebersetzt in den HALO-Look. Flaechen stehen, Inhalte zoomen.
   Ohne Skript oder bei reduced motion bleibt die Seite ruhig: dann wird
   .hdvl--motion nie gesetzt und alle Inhalte stehen untereinander. */
(function () {
  var root = document.querySelector('.hdvl');
  if (!root) return;

  var clamp = function (v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var range = function (v, a, b) { return clamp((v - a) / (b - a)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var eo = function (t) { return 1 - Math.pow(1 - t, 3); };
  var qs = function (s, el) { return (el || root).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var pin = function (el) { var r = el.getBoundingClientRect(), vh = window.innerHeight; return { p: clamp(-r.top / Math.max(1, r.height - vh)), r: r, vh: vh }; };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Woerter einzeln fassen, fuer das Aufbauen von Saetzen */
  qsa('[data-hdv-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span'); s.className = 'w'; s.textContent = w;
      el.appendChild(s); if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });

  /* Header: transparent ueber dem Hero, danach wie gewohnt */
  var hdr = document.querySelector('[data-halo-header]');
  var hero = qs('[data-hdv="hero"]');
  var vhead = qs('[data-hdv-vhead]');
  var setHead = function () {
    if (hdr) root.style.setProperty('--head', hdr.offsetHeight + 'px');
    if (vhead) root.style.setProperty('--vhead', vhead.offsetHeight + 'px');
  };
  setHead(); window.addEventListener('resize', setHead); window.addEventListener('load', setHead);
  if (hdr && hero && hdr.classList.contains('halo-header--solid')) {
    hdr.classList.remove('halo-header--solid'); hdr.classList.add('halo-header--overlay');
    var tone = function () {
      var over = hero.getBoundingClientRect().bottom > hdr.offsetHeight + 2;
      hdr.classList.toggle('is-stuck', !over);
      hdr.setAttribute('data-tone', over ? 'dark' : 'light');
    };
    window.addEventListener('scroll', tone, { passive: true }); tone();
  }

  /* Podcast: Folge antippen oeffnet das Player-Fenster, Spotify laedt erst dann */
  var modal = qs('[data-hdv-modal]');
  if (modal) (function () {
    var mt = qs('[data-hdv-mtitle]', modal), mp = qs('[data-hdv-mplayer]', modal), x = qs('.hdv-modal__x', modal), back = null;
    function open(title) {
      back = document.activeElement;
      mt.textContent = title || 'Podcast';
      var f = document.createElement('iframe');
      f.src = 'https://open.spotify.com/embed/show/0RUxzGQBTRYv6KOty1bdSp?utm_source=generator';
      f.title = 'HALO Podcast bei Spotify';
      f.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
      mp.innerHTML = ''; mp.appendChild(f);
      modal.hidden = false; document.documentElement.style.overflow = 'hidden'; x.focus();
    }
    function close() {
      modal.hidden = true; mp.innerHTML = ''; document.documentElement.style.overflow = '';
      if (back && back.focus) back.focus();
    }
    qsa('[data-hdv-listen]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(a.getAttribute('data-title')); });
    });
    qsa('[data-hdv-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('hdvl--motion');

  var subs = [];
  var on = function (fn) { subs.push(fn); };

  /* 1 Hero: Vorhang lichtet sich, Bild zoomt zurueck, Name steigt ruhig mit */
  if (hero) (function () {
    var img = qs('[data-hdv-hero-img]', hero), veil = qs('[data-hdv-veil]', hero), hint = qs('[data-hdv-hint]', hero),
      name = qs('[data-hdv-name]', hero), last = -1;
    on(function () {
      var o = pin(hero); if (o.r.bottom < 0) return;
      if (Math.abs(o.p - last) < 0.0005) return; last = o.p;
      var p = o.p;
      img.style.transform = 'scale(' + lerp(1.16, 1, eo(range(p, 0, 0.75))).toFixed(4) + ')';
      veil.style.opacity = lerp(1, 0.55, eo(range(p, 0, 0.5))).toFixed(3);
      hint.style.opacity = (1 - range(p, 0, 0.15)).toFixed(3);
      if (name) name.style.transform = 'translate3d(0,' + (-eo(range(p, 0.1, 1)) * 40).toFixed(1) + 'px,0)';
    });
  })();

  /* 2 Laufband: driftet, Scroll schiebt und neigt es */
  qsa('[data-hdv="marquee"]').forEach(function (wrap) {
    var track = qs('[data-hdv-track]', wrap), x = 0, lastY = window.scrollY, lastT = 0, v = 0, dir = -1;
    on(function (t) {
      var dt = lastT ? Math.min(0.1, (t - lastT) / 1000) : 1 / 60; lastT = t;
      var y = window.scrollY, dy = y - lastY; lastY = y;
      if (dy) dir = dy > 0 ? -1 : 1;
      v += (dy / Math.max(dt, 0.001) - v) * 0.1;
      var r = wrap.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      x += dir * (40 + Math.min(Math.abs(v), 3000) * 0.4) * dt;
      var half = track.scrollWidth / 2; if (half > 0) x = ((x % half) - half) % half;
      track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0) skewX(' + clamp(-v / 250, -12, 12).toFixed(2) + 'deg)';
    });
  });

  /* Saetze bauen sich Wort fuer Wort auf */
  qsa('[data-hdv-words]').forEach(function (el) {
    var ws = qsa('.w', el), n = ws.length, last = -1;
    on(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var k = range(vh * 0.88 - r.top, 0, r.height + vh * 0.32);
      if (Math.abs(k - last) < 0.002) return; last = k;
      ws.forEach(function (w, i) { w.style.opacity = (0.16 + 0.84 * clamp(k * n * 1.1 - i)).toFixed(3); });
    });
  });

  /* 4 Werdegang: Strecke, Jahreszahl laeuft mit */
  qsa('[data-hdv="tl"]').forEach(function (sec) {
    var items = qsa('.hdv-tl__list li', sec), n = items.length, years = items.map(function (li) { return +li.getAttribute('data-y'); }),
      yearEl = qs('[data-hdv-year]', sec), fill = qs('[data-hdv-fill]', sec), dot = qs('[data-hdv-dot]', sec),
      count = qs('[data-hdv-count]', sec), nodesWrap = qs('[data-hdv-nodes]', sec), nodes = [], cur = -1, last = -1;
    items.forEach(function (li, i) { var d = document.createElement('i'); d.style.left = (i / (n - 1) * 100) + '%'; nodesWrap.appendChild(d); nodes.push(d); });
    on(function () {
      var o = pin(sec); if (o.r.bottom < 0 || o.r.top > o.vh) return;
      if (Math.abs(o.p - last) < 0.00005) return; last = o.p;
      var u = range(o.p, 0.04, 0.94), f = u * (n - 1);
      fill.style.transform = 'scaleX(' + u.toFixed(4) + ')';
      dot.style.left = (u * 100).toFixed(3) + '%';
      var idx = clamp(Math.round(f), 0, n - 1);
      if (idx !== cur) {
        cur = idx;
        items.forEach(function (li, i) { li.classList.toggle('on', i === idx); });
        nodes.forEach(function (d, i) { d.classList.toggle('on', i <= idx); });
        count.textContent = pad(idx + 1);
        roll(+yearEl.textContent || years[idx], years[idx]);
      }
    });
    /* Jahreszahl rollt beim Stationswechsel kurz auf den neuen Wert */
    var rollId = 0;
    function roll(from, to) {
      var id = ++rollId, t0 = performance.now(), dur = 420;
      (function step(now) {
        if (id !== rollId) return;
        var k = eo(clamp((now - t0) / dur));
        yearEl.textContent = Math.round(lerp(from, to, k));
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    }
  });

  /* 7 Buecher: das Tuch gleitet nach oben weg */
  qsa('[data-hdv="book"]').forEach(function (b) {
    var sheet = qs('[data-hdv-sheet]', b), img = qs('img', b), last = -1;
    on(function () {
      var r = b.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var k = eo(range(vh - r.top, vh * 0.15, vh * 0.75));
      if (Math.abs(k - last) < 0.001) return; last = k;
      sheet.style.transform = 'translate3d(0,' + (-k * 101).toFixed(2) + '%,0)';
      if (img) img.style.transform = 'scale(' + lerp(1.14, 1, k).toFixed(4) + ')';
    });
  });

  /* 8 Podcast: Filmrolle, die Folge in der Mitte ist scharf */
  qsa('[data-hdv="reel"]').forEach(function (sec) {
    var track = qs('[data-hdv-reeltrack]', sec), cards = qsa('.hdv-ep', sec), imgs = cards.map(function (c) { return qs('img', c); }),
      bar = qs('[data-hdv-reelbar]', sec), count = qs('[data-hdv-reelcount]', sec), total = qs('[data-hdv-reeltotal]', sec), last = -1;
    if (total) total.textContent = pad(cards.length);
    on(function () {
      var o = pin(sec); if (o.r.bottom < 0 || o.r.top > o.vh) return;
      if (Math.abs(o.p - last) < 0.00005) return; last = o.p;
      var vw = window.innerWidth, k = range(o.p, 0.04, 0.96), mobile = vw < 881;
      var travel = Math.max(0, track.offsetLeft + track.scrollWidth - vw * (mobile ? 0.9 : 0.94));
      if (mobile) travel = Math.max(0, track.scrollWidth - vw * 0.75);
      track.style.transform = 'translate3d(' + (-k * travel).toFixed(1) + 'px,0,0)';
      var focus = vw * (mobile ? 0.45 : 0.62), best = Infinity, near = 0;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), off = (r.left + r.width / 2 - focus) / vw, a = clamp(Math.abs(off) * 1.6);
        c.style.opacity = (1 - a * 0.6).toFixed(3);
        c.style.transform = 'scale(' + (1 - a * 0.08).toFixed(4) + ')';
        if (imgs[i]) imgs[i].style.transform = 'translate3d(' + (off * -50).toFixed(1) + 'px,0,0) scale(1.14)';
        if (Math.abs(off) < best) { best = Math.abs(off); near = i; }
      });
      bar.style.transform = 'scaleX(' + k.toFixed(4) + ')';
      count.textContent = pad(near + 1);
    });
  });

  /* 9 Buehne: Fotos in eigener Geschwindigkeit */
  qsa('[data-hdv-par]').forEach(function (el) {
    var s = +el.getAttribute('data-hdv-par');
    on(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      var off = (r.top + r.height / 2 - vh / 2);
      el.style.transform = 'translate3d(0,' + (off * s).toFixed(1) + 'px,0)';
    });
  });

  /* 5 Kennzahlen: zaehlen einmal hoch, sobald sie im Bild sind */
  qsa('[data-hdv-num]').forEach(function (li) {
    var v = qs('.v', li), to = +li.getAttribute('data-hdv-num'), sfx = li.getAttribute('data-s') || '', t0 = 0, done = false;
    v.textContent = '0';
    on(function (t) {
      if (done) return;
      var r = li.getBoundingClientRect();
      if (!t0) { if (r.top < window.innerHeight * 0.85 && r.bottom > 0) t0 = t; else return; }
      var k = eo(clamp((t - t0) / 1400));
      v.textContent = Math.round(to * k) + (k >= 1 ? sfx : '');
      if (k >= 1) done = true;
    });
  });

  /* Flaechen stehen, der Inhalt zoomt beim Herein- und Hinausscrollen */
  qsa('[data-hdv-zoom]').forEach(function (el) {
    var sec = el.closest('section'), last = -1;
    on(function () {
      var r = sec.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var kin = eo(range(vh - r.top, 0, vh * 0.7)), kout = range(vh * 0.4 - r.bottom, 0, vh * 0.4);
      var key = kin * 1000 + kout; if (Math.abs(key - last) < 0.002) return; last = key;
      el.style.transform = 'scale(' + (lerp(0.9, 1, kin) * lerp(1, 0.94, kout)).toFixed(4) + ')';
      el.style.opacity = (lerp(0, 1, kin) * lerp(1, 0.35, kout)).toFixed(3);
    });
  });

  var loop = function (t) { for (var i = 0; i < subs.length; i++) subs[i](t); requestAnimationFrame(loop); };
  requestAnimationFrame(loop);
})();
